import type { Dispatch, RefObject, SetStateAction } from 'react';
import { useEffect, useRef, useState } from 'react';

export default function useComponentVisible<T extends HTMLElement>(
  initialIsVisible: boolean,
  onClickOutside?: () => void
): {
  ref: RefObject<T>;
  isComponentVisible: boolean;
  setIsComponentVisible: Dispatch<SetStateAction<boolean>>;
} {
  const [isComponentVisible, setIsComponentVisible] = useState(initialIsVisible);
  const ref = useRef<T>(null);

  const handleClickOutside = ({ target }: MouseEvent) => {
    if (!(target instanceof HTMLElement)) return;
    if (ref.current && !ref.current.contains(target)) {
      setIsComponentVisible(false);
      if (onClickOutside) onClickOutside();
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  });

  return { ref, isComponentVisible, setIsComponentVisible };
}
